import * as actions from '../actions/currentSessionActionTypes';


const initialState = {
  sessionToken: "",
  sessionDateTime: "",
  sessionValidUntil: "",
  sessionLoggedIn: "false",
  sessionInfoMessage: "",
  sessionErrorMessage: ""  
}


function currentSession(state = initialState, action) {  
  switch (action.type) {
    case actions.CURRENT_SESSION_SET_TOKEN:
      return {
        ...state, 
        sessionToken: action.sessionToken
      }
    case actions.CURRENT_SESSION_SET_DATETIME:
      return {
        ...state, 
        sessionDateTime: action.sessionDateTime
      }
    case actions.CURRENT_SESSION_SET_VALIDUNTIL:
        return {
          ...state, 
          sessionValidUntil: action.sessionValidUntil
        }

    case actions.CURRENT_SESSION_SET_LOGGEDIN:
      return {
        ...state, 
        sessionLoggedIn: action.sessionLoggedIn
      }
    case actions.CURRENT_SESSION_SET_INFOMESSAGE:
      return {
        ...state, 
        sessionInfoMessage: action.sessionInfoMessage
      }
    case actions.CURRENT_SESSION_SET_ERRORMESSAGE:
      return {
        ...state, 
        sessionErrorMessage: action.sessionErrorMessage
      }

    default:        
      return state
  } 
}
  
export default currentSession